import { create } from 'zustand'
import type { User } from '~/types/user'

type SessionState = {
  user: User | null
  setUser: (user: User) => void
  resetState: () => void
}

const initialState = {
  user: null as User | null,
}

export const useSessionStore = create<SessionState>((set) => ({
  ...initialState,
  setUser: (user: User) => set({ user }),
  resetState: () => set(initialState),
}))
